<template>
  <v-container grid-list-md fluid ma-0 class="header-container">
    <v-layout row wrap>
      <v-flex xs12 pa-3 class="header-content text-xs-center white--text headline font-weight-medium">
        Master Data
      </v-flex>
      <utility-backButton/>
      <v-flex xs12>
        <v-card-title>
          <!-- <span class="title font-weight-bold"> Master Data </span> -->
          <v-spacer></v-spacer>
          <div>
            <v-flex xs12>
              <v-select
                dense
                hide-details
                :items="[{text: 'Active', value: false},
                {text: 'InActive', value: true},
                {text: 'Both', value: 'Both'}]"
                label="Filter on"
                v-model="filterActive"
              >
              </v-select>
            </v-flex>
          </div>
          <div>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            hide-details
            color="pipefishGreen"
          >
            <template slot="label">
              <span>Search</span>
            </template>
          </v-text-field>
          </div>
        </v-card-title>
        Total Shown: {{displayData.length}}
        <v-data-table
            :headers="headers"
            :items="displayData"
            :search="search"
            sort-icon="mdi-menu-down"
            hide-actions
          >
            <template v-slot:items="props">
              <td> {{props.item.client}} </td>
              <td> {{props.item.project}} </td>
              <td> {{props.item.value.Name}} </td>
              <td> {{props.item.value.practice.Code}} </td>
              <td> {{props.item.value.statement.Name}} </td>
              <td> {{props.item.isActive}} </td>
            </template>
          </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {
  mapState,
  mapMutations
} from 'vuex'

export default {
  data: () => ({
    filterActive: false,
    search: '',
    headers: [
      {text: 'Client', value: 'client'},
      {text: 'Project', value: 'project'},
      {text: 'Activity', value: 'value.Name'},
      {text: 'Practice', value: 'value.practice.Code'},
      {text: 'SoW', value: 'value.statement.Name'},
      {text: 'IsActive', value: 'isActive'}
    ]
  }),
  created() {
    if(this.timesheetData.length == 0) {
      // no data just route to /admin
      this.$router.push('/admin')
    }
  },
  computed: {
    ...mapState('api', ['timesheetData']),
    displayData: function() {
      var projects = this.timesheetData.map(client => {
        return client.projects.map(project => {
          return project.activities.filter(activity => activity.IsActive != this.filterActive).map(activity => {
            return {
              isActive: activity.IsActive,
              value: activity,
              project: project.Name,
              client: client.Name
            }
          })
        })
      })
      return projects.flat().flat()
    }
  },
}
</script>

<style scoped>
/* table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
} */
</style>
